export default `
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.App {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.meldooModal {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
}


.MuiSvgIcon-root {
    fill: currentColor;
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 1.5rem;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    flex-shrink: 0;
    user-select: none;
  }
  .MuiSvgIcon-colorPrimary {
    color: #3f51b5;
  }
  .MuiSvgIcon-colorSecondary {
    color: #f50057;
  }
  .MuiSvgIcon-colorAction {
    color: rgba(0, 0, 0, 0.54);
  }
  .MuiSvgIcon-colorError {
    color: #f44336;
  }
  .MuiSvgIcon-colorDisabled {
    color: rgba(0, 0, 0, 0.26);
  }
  .MuiSvgIcon-fontSizeInherit {
    font-size: inherit;
  }
  .MuiSvgIcon-fontSizeSmall {
    font-size: 1.25rem;
  }
  .MuiSvgIcon-fontSizeLarge {
    font-size: 2.1875rem;
  }

`;
